import React, { useState } from "react";
import axios from "axios";
import "./Audience.css";
import "./RequestOrganizer.css";

const RequestOrganizer = () => {
  const [eventName, setEventName] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(""); // NEW
  const [isError, setIsError] = useState(false); // NEW

  const submitRequest = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(""); // reset

    try {
      const token = localStorage.getItem("token");

      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/audience/organizerRequest`,
        { eventName, reason },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setMessage("Request sent to admin!");
      setIsError(false);

      setEventName("");
      setReason("");
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.message || "Request failed");
      setIsError(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="audience-container">
      <h2>Request Organizer Access</h2>

      {/* Notification */}
      {message && (
        <div className={`notification ${isError ? "error" : "success"}`}>
          {message}
        </div>
      )}

      <form className="request-form" onSubmit={submitRequest}>
        <label>Event Name</label>
        <input
          type="text"
          value={eventName}
          onChange={(e) => setEventName(e.target.value)}
          required
        />

        <label>Why do you want to organize this event?</label>
        <textarea
          rows="4"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          required
        />

        <button type="submit" disabled={loading}>
          {loading ? "Submitting..." : "Submit Request"}
        </button>
      </form>
    </div>
  );
};

export default RequestOrganizer;